import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportJobChecks {
    loading: boolean;
    scheduleDate: string;
    errors: any;
}

export class ReportJobChecksData extends React.Component<RouteComponentProps<{}>, ReportJobChecks> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            scheduleDate: "",
            errors: {}
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    this.setState({ loading: false });
                } else if (res.data == false) {
                    //redirect to 403 permission denied
                    this.props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = "";
        this.setState(change);
    }

    validate = () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.scheduleDate) {
            formIsValid = false;
            errors["scheduleDate"] = "Schedule Date is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (this.validate()) {
            var url = "/report/JobChecks/" + this.state.scheduleDate + "/-1/-1/-1/-1";
            window.open(url, '_blank');
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {

        return (
            <div>
                <div>
                    <h1>Job Arrival / Completion Checklist Report</h1>
                </div>
                <div className="marginTop20">
                    <span>Select the Schedule Date to run the report. </span>
                </div>
                <div>
                    <label className="input-group" htmlFor="scheduleDate">
                        <span className="label">Schedule Date</span>
                        <input type='date' id="scheduleDate" name="scheduleDate" className='input' value={this.state.scheduleDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["scheduleDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["scheduleDate"]}</span>
                </div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={this.runReport}>Run Report</button>
            </div>
        );

    }

};